// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"bbecda85","795":"196770a8"}[chunkId] + ".chunk.css";
};